// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "" + ({"197":"75fc9c18","293":"component---src-pages-index-js","518":"8a28b14e"}[chunkId] || chunkId) + "." + {"197":"fa4a40407606a79e22a0","293":"2ea387686f00b8d7fc7e","518":"2fcec6016c80a9098c2f","779":"2bbb9f0a1a08b1fdff7d"}[chunkId] + ".js";
};